import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import { modals } from '@modals';
import { alert } from '@services/alert';
import { useGetter, useCommit, Shop } from '@store';
import { ensureError } from '@tools/ensure-error';
import * as currencies from '@utils/currencies';

import DisplayPrice from '@components/Display/DisplayPrice.vue';

import { faInfo } from '@icons/solid/faInfo';

/**
 * `AddOnsRackCard` component properties.
 */
export interface Props {
  product: Shop.Item;
}


declare module 'vue/types/vue' {
  export interface Vue {
    AddOnsRackCard: ComponentWithProps<Props>;
  }
}

const __default__ = { name: 'AddOnsRackCard' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    product: null
  },
  setup(__props: any) {

const props = __props as {
  product: Shop.Item;
};



const containsItemWithScenes = useGetter('cart/containsItemWithScenes');
const addItem = useCommit('cart/ADD_ITEM');

/** Product ID. */
const id = computed(() => {
  return props.product.id;
});

/** Product title. */
const title = computed(() => {
  return props.product.name;
});

/** Product description. */
const description = computed(() => {
  return props.product.description;
});

/** Product price. */
const price = computed(() => {
  // NOTE: Price currently assumed to be first `price` in the `prices` array
  // with a currency in USD.
  return currencies.getProductPrice(props.product);
});

/** Primary product image. */
const image = computed(() => {
  return props.product.images[0];
});

/** Whether or not the product can be added to the cart. */
const isAddable = computed(() => {
  return (
    // !props.product.owned &&
    !containsItemWithScenes.value(props.product.scenes ?? [])
  );
});

/** Is a certification. */
const isCertification = computed(() => {
  return !!props.product.tags?.some(
    (tag) => tag.toLowerCase() === 'certification',
  );
});

/** Whether or not there are any product tags to display.  */
const productTagsPresent = computed(() => {
  return (
    props.product.recommended || props.product.onSale || props.product.owned
  );
});

/**
 * Summon product details modal.
 */
function showDetails() {
  void modals.shop.productDetails({ productId: id.value });
}

/**
 * Add product to the shopping cart.
 */
function addToCart() {
  let error: ensureError.Error | null = null;

  try {
    addItem({ item: props.product });
  } catch (err) {
    error = ensureError(err);
  }

  if (!error) return;

  if (error['code'] === 'DUPLICATE_ITEM_SCENES') {
    return alert.warning(error.message);
  }

  if (error['code'] === 'DUPLICATE_ITEM_SCENES') {
    return alert.warning(error.message);
  }
}

return { __sfc: true,props, containsItemWithScenes, addItem, id, title, description, price, image, isAddable, isCertification, productTagsPresent, showDetails, addToCart, DisplayPrice, faInfo }
}

})